// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2c46bb47c031b10fb0a3c357a288c27fbab35ab1.chunk.js";
};